import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import axios from 'axios';
// import TranslationEnFile from "../Locals/en.json"

const Translate = async (languageResponse) => {
    try {
        const [translations, response] = await new Promise((resolve, reject) => {
            let fetchedData = null;
            const fetchData = async () => {
                try {
                    const result = languageResponse;
                    if (result?.translationFilePath) {
                        const isValidURL = result?.translationFilePath.startsWith('http') || result?.translationFilePath.startsWith('https');
                        if (!isValidURL) {
                            throw new Error('Invalid translation file URL');
                        }
                        const data = await axios.get(result?.translationFilePath);
                        const translationData = (data?.data && typeof data?.data === 'object') ? data?.data : {};
                        fetchedData = [translationData, result];
                    } else {
                        fetchedData = [{ "demo": "demo" }, result];
                    }

                    resolve(fetchedData);
                } catch (error) {
                    reject(error);
                }
            };

            fetchData();
        });

        const langCode = response?.Language_Code || 'en';
        const translation = translations ? translations : { "demo": "demo" };

        if (i18n.isInitialized) {
            // If already initialized, update resources and change language
            i18n.addResourceBundle(langCode, 'translation', translation, true, true);
            await i18n.changeLanguage(langCode);
        } else {
            // Initial initialization
            const resources = {
                [langCode]: {
                    translation: translation
                }
            };
            await i18n
                .use(initReactI18next)
                .init({
                    resources,
                    lng: langCode,
                    fallbackLng: 'en',
                    interpolation: {
                        escapeValue: false,
                    },
                    react: {
                        useSuspense: false // Often helps with instant updates
                    }
                });
        }
    } catch (error) {
        console.error("Error initializing i18n:", error);
    }
};

export const initializeI18n = Translate;
export default i18n;
